import { render, staticRenderFns } from "./SaveInvestigationModal.vue?vue&type=template&id=67ecd965&"
import script from "./SaveInvestigationModal.vue?vue&type=script&lang=ts&"
export * from "./SaveInvestigationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports